import React from 'react';
import {DatePicker, Select} from 'antd';

class IndustrySelector extends React.Component {
    state = {
        value : '',
        industries : []
    }

    onchange(value){
        this.setState({
            value :  value
        });
        this.props.onChange(value);
    }
    render() {
        const industries = this.props.industries;
        return (
            <Select
                showSearch
                style={{ width: 200 ,  ...this.props.style}}
                placeholder={this.props.placeholder}
                optionFilterProp="children"
                size={this.props.size || "default"}
                onChange={(value) => this.onchange(value)}
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                value={this.props.value || undefined }
                size={this.props.size}
             >
                {industries.map((industry, idx) => {
                    return <Select.Option value={industry.value} key={industry.code}>{industry.value}</Select.Option>
                })}
            </Select>
        )
    }

}

export default IndustrySelector;
